module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.878ad71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Regular.woff
// module id = ByIg
// module chunks = 0